<dx-tabs
  class="yo-dx-tab-menu"
  [items]="items"
  [selectedItem]="selectedItem"
  displayExpr="text"
  stylingMode="secondary"
  [scrollByContent]="true"
  [showNavButtons]="true"
  [style.--yo-tab-menu-width]="width"
  [style.--yo-tab-menu-margin-bottom]="marginBottom"
  [style.--yo-tab-button-size]="buttonSize"
  [style.--yo-tab-button-radius]="buttonRadius"
  [style.--yo-tab-button-margin]="buttonMargin"
  (onItemClick)="onItemClick($event)">
</dx-tabs>
